import { IStyle, mergeStyleSets } from "@fluentui/react";

export const getAppStyles = (
  isNavCollapsed: boolean,
  isCustomerAccount?: boolean
) => {
  const rootStyle = isCustomerAccount
    ? {
        root: {
          marginLeft: isNavCollapsed ? "48px" : "228px",
          marginRight: "0",
          backgroundColor: "white",   
          position: "sticky" ,
          paddingTop:'48px',    
        } as IStyle,
      }
    : {
        root: {
          marginLeft: isNavCollapsed ? "48px" : "228px",
          marginRight: "0",
          backgroundColor: "white",
          position: "sticky",
          paddingTop:'48px',
        } as IStyle ,
      };
  return mergeStyleSets(rootStyle);
};
